<template>
  <div class="separator">
    
  </div>
</template>

<script>

export default {
  name: 'Separator',
  components: {
    
  }
}
</script>

<style scoped>
.separator {
  height: 1px;
  width: 100%;
  margin: 20px 0 10px 0;
  background-color: #dddddd;
}

</style>